import { render, staticRenderFns } from "./hit_color.vue?vue&type=template&id=622ce582&"
import script from "./hit_color.vue?vue&type=script&lang=js&"
export * from "./hit_color.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports